import { useEffect, useState } from "react";
const API = import.meta.env.VITE_API_BASE_URL;

export default function DevLogs(){
  const [actions, setActions] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  async function load(){
    setLoading(true);
    try{
      const [a, j] = await Promise.all([
        fetch(`${API}/v1/dev/audit/actions?limit=50`, { credentials:"include" }).then(r=>r.json()),
        fetch(`${API}/v1/dev/audit/jobs?limit=50`, { credentials:"include" }).then(r=>r.json()),
      ]);
      setActions(a.items || []);
      setJobs(j.items || []);
      setMsg("");
    }catch(e){
      console.error(e);
      setMsg("Load failed (are you DEV?)");
    }
    setLoading(false);
  }

  useEffect(()=>{ load(); },[]);

  return (
    <div style={{ padding:16 }}>
      <h1>DEV • Logs</h1>
      <p style={{ fontSize:12, opacity:.7 }}>Status: {msg}</p>
      {loading ? <p>Loading…</p> : (
        <>
          <h2>Actions</h2>
          <table cellPadding="6" style={{ width:"100%", borderCollapse:"collapse", marginBottom:16 }}>
            <thead><tr style={{textAlign:"left", borderBottom:"1px solid #eee"}}>
              <th>When</th><th>Email</th><th>Action</th><th>Entity</th><th>Meta</th>
            </tr></thead>
            <tbody>
              {actions.map((a,i)=>(
                <tr key={i} style={{ borderBottom:"1px solid #f4f4f4" }}>
                  <td>{a.created_at}</td>
                  <td>{a.actor_email}</td>
                  <td>{a.action}</td>
                  <td>{a.entity_type}:{a.entity_id}</td>
                  <td><code style={{fontSize:12}}>{a.meta}</code></td>
                </tr>
              ))}
              {actions.length===0 && <tr><td colSpan={5}>No actions.</td></tr>}
            </tbody>
          </table>

          <h2>Jobs</h2>
          <table cellPadding="6" style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr style={{textAlign:"left", borderBottom:"1px solid #eee"}}>
              <th>When</th><th>Type</th><th>Status</th><th>Details</th>
            </tr></thead>
            <tbody>
              {jobs.map((j,i)=>(
                <tr key={i} style={{ borderBottom:"1px solid #f4f4f4" }}>
                  <td>{j.created_at}</td>
                  <td>{j.job_type}</td>
                  <td>{j.status}</td>
                  <td><code style={{fontSize:12}}>{j.details}</code></td>
                </tr>
              ))}
              {jobs.length===0 && <tr><td colSpan={4}>No jobs.</td></tr>}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}